import { ServiceDefinition } from '@pershing/pershing-core';

export class OptionTradingServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'trading/option';
    version: string = 'v1';
    family: string = 'pershing';
    appName: string = 'option-trading';
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!OptionTradingServiceDefinition.instance) {
            OptionTradingServiceDefinition.instance = new OptionTradingServiceDefinition();
            if (platform === 'retail') {
                OptionTradingServiceDefinition.instance.family = 'netxinvestor';
                OptionTradingServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return OptionTradingServiceDefinition.instance;
    }

    private constructor() {
        //intentional empty constructor
    }
}
